// Other Pages
import Login from './pages/Login.svelte';
import Profile from './pages/Profile.svelte';
import Settings from './pages/Settings.svelte';

// Admins
import Admins from './pages/Admins/Admins.svelte';

// Products
import Products from './pages/Products/Products.svelte';
import AddProduct from './pages/Products/AddProduct.svelte';
import ProductsDetails from './pages/Products/ProductsDetails.svelte';

// Products
import FStyles from './pages/FStyles/FStyles.svelte';
import AddFStyle from './pages/FStyles/AddFStyle.svelte';
import FStylesDetails from './pages/FStyles/FStylesDetails.svelte';

// Suppliers
import Suppliers from './pages/Suppliers/Suppliers.svelte';
import AddSupplier from './pages/Suppliers/AddSupplier.svelte';
import SuppliersDetails from './pages/Suppliers/SuppliersDetails.svelte';

// Customers
import Customers from './pages/Customers/Customers.svelte';
import AddCustomer from './pages/Customers/AddCustomer.svelte';
import CustomersDetails from './pages/Customers/CustomersDetails.svelte';

// Customers
import Cmts from './pages/Cmts/Cmts.svelte';
import AddCmt from './pages/Cmts/AddCmt.svelte';
import CmtsDetails from './pages/Cmts/CmtsDetails.svelte';

// Orders
import Orders from './pages/Orders/Orders.svelte';
import AddOrder from './pages/Orders/AddOrder.svelte';
import OrdersDetails from './pages/Orders/OrdersDetails.svelte';
import StylesDetails from './pages/Orders/Materials/StylesDetails.svelte';

// Reports
import Stats from './pages/Stats/Stats.svelte'

// Routes
const routes = {
  '/': Products,
  '/products': Products, /*📌*/
  '/addproduct': AddProduct,
  '/products/:id': ProductsDetails,

  '/fstyles': FStyles, /*📌*/
  '/addfstyle': AddFStyle,
  '/fstyles/:id': FStylesDetails,

  '/suppliers': Suppliers, /*📌*/
  '/addsupplier': AddSupplier,
  '/suppliers/:id': SuppliersDetails,

  '/customers': Customers, /*📌*/
  '/addcustomer': AddCustomer,
  '/customers/:id': CustomersDetails,

  '/cmts': Cmts, /*📌*/
  '/addcmt': AddCmt,
  '/cmts/:id': CmtsDetails,

  '/administrators': Admins, /*📌*/

  '/reports': Stats, /*📌*/

  '/orders': Orders,
  '/addorder': AddOrder,
  '/orders/:id': OrdersDetails,
  '/styles/:id': StylesDetails,

  '/login': Login,
  '/profile': Profile,
}

export default routes;